export default __webpack_public_path__ + "static/media/CoinActive.1fb11d42.svg";